/**
 * App.jsx - Shell Application Router
 *
 * Shell Design System v5.0
 *
 * ROUTES:
 * - / : Main application (PlaceholderApp by default)
 * - /arc/design-system : Design system documentation
 *
 * TO CUSTOMIZE:
 * 1. Replace PlaceholderApp import with your own component
 * 2. Add more routes as needed
 */

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import PlaceholderApp from './PlaceholderApp'
import DesignSystemShowcase from './pages/DesignSystemShowcase'

function App() {
  return (
    <Routes>
      <Route path="/" element={<PlaceholderApp />} />
      <Route path="/arc/design-system" element={<DesignSystemShowcase />} />
    </Routes>
  )
}

export default App
